
const styles = {
    teamIcons: {
        width: '40px', height: "40px", border: '1px solid #fff', display: 'flex',
            justifyContent: 'center', alignItems: 'center', margin: '10px', color: '#fff',
    }

}

export default styles;